import { useEffect } from 'react';

const addZeSettings = () => {
    window.zESettings = {
        webWidget: {
            chat: {
                departments: {
                    enabled: ['veeva id support'],
                },
            },
        },
    };
};

/**
 * Adds Zendesk Chat Widget to a page and toggles visibility when navigating between pages.
 */
const useZendesk = () => {
    useEffect(() => {
        if (window.zE) {
            window.zE.show();
        } else {
            addZeSettings();
            const script = document.createElement('script');
            // sandbox script
            script.src =
                'https://static.zdassets.com/ekr/snippet.js?key=47ab6b02-9db7-42e4-8d78-e15dfa3286f2';
            script.id = 'ze-snippet';
            document.head.appendChild(script);
        }

        return () => {
            window.zE?.('webWidget', 'hide');
        };
    }, []);
};

export default useZendesk;
